<script>
export default {
    type: "column2d",
    width: "100%",
    height: "350",
    dataFormat: "json",
    dataSource: {
        chart: {
            // caption: "Countries With Most Oil Reserves [2017-18]",
            // subcaption: "In MMbbl = One Million barrels",
            showvalues: "1",
            xaxisname: "Jenis Kutipan Hasil",
            yaxisname: "Jumlah Kutipan Hasil",
            // numbersuffix: "K",
            numberprefix: "RM",
            theme: "fusion",
        },
    data: [
            {
                label: "LESEN, BAYARAN PENDAFTARAN DAN PERMIT",
                value: "110",
                "color": "#FF9F45",
            },
            {
                label: "PERKHIDMATAN DAN BAYARAN PERKHIDMATAN",
                value: "80",
                "color": "#F76E11",
            },
            {
                label:"PEROLEHAN DARI JUALAN BARANG-BARANG",
                value: "125",
                "color": "#FFBC80",
            },
            {
                label: "SEWAAN",
                value: "55",
                "color": "#FF9F45",
            },
            {
                label:"FAEDAH DAN PEROLEHAN DARI  PELABURAN",
                value: "95",
               "color": "#F76E11",
            },
            {
                label:"DENDA DAN HUKUMAN",
                value: "75",
                "color": "#FFBC80",
            },
            {
                label:    "SUMBANGAN DAN BAYARAN GANTI DARIPADA LUAR NEGERI DAN SUMBANGAN TEMPATAN",
                value: "90",
                "color": "#FF9F45",
            },
        ],
    },
};
</script>
